import {
  MenuItemPriceTypeSchema,
  type MenuItemPriceType as GeneratedMenuItemPriceType
} from '~/services/api/generated'

export type MenuItemPriceType = GeneratedMenuItemPriceType

export const MenuItemPriceType = {
  EACH: MenuItemPriceTypeSchema.enum.each,
  GROUP_TRAY: MenuItemPriceTypeSchema.enum.group_tray,
  PER_PERSON: MenuItemPriceTypeSchema.enum.per_person
}

export const MenuItemPriceTypeValues = [
  MenuItemPriceTypeSchema.enum.each,
  MenuItemPriceTypeSchema.enum.group_tray,
  MenuItemPriceTypeSchema.enum.per_person
]
